// Modi:
// normal = einzelner Rabatt in %
// salesPerson = Rabatt für alle Varianten in %
// colorVariant = Rabatt für alle Größen innerhalb einer Farbe in %
// manualPrice = manuell gesetzter Preis (nicht propagiert)
// salesPersonPrice = Preis für alle Varianten
// colorVariantPrice = Preis für alle Größen innerhalb einer Farbe
const formatDiscount = (value) => value.toString().replace(".", ",");

export function enableEditableInputs() {
    let currentEditing = null;
    let originalValue  = null;
    let originalText   = null;
    let originalClass  = null;

    const setupEditable = (wrapper, mode = "normal") => {
        const isManualPrice = wrapper.classList.contains("js-manualPriceInput");

        const display  = wrapper.querySelector(".editable-display");
        const input    = isManualPrice
            ? wrapper.querySelector("input.manual_price_discount")
            : wrapper.querySelector("input.percent_discount, input.percent_discount_all_variants, input[type='number']");
        const editIcon = wrapper.querySelector(".icon-edit");
        const saveIcon = wrapper.querySelector(".icon-save");

        if (!display || !input || !editIcon || !saveIcon) return;

        const parentBox       = wrapper.closest(".itemBasketBox");
        const dataId          = parentBox?.getAttribute("data-id");
        const basketContainer = wrapper.closest(".contentTabs__basketWrapper") ?? document;

        const toggleToEdit = () => {
            // anderes Feld schließen
            if (currentEditing && currentEditing !== wrapper) {
                cancelEdit(currentEditing);
            }
            currentEditing = wrapper;
            originalValue  = input.value;
            originalText   = display.textContent;
            originalClass  = display.classList.contains("discount");

            display.style.display = "none";
            input.style.display = "inline-block";
            input.focus();
            input.select();
            editIcon.style.display = "none";
            saveIcon.style.display = "inline-block";
        };

        const toggleToDisplay = () => {
            const value = parseFloat(input.value);
            if (isNaN(value) || value < 0) {
                cancelEdit(wrapper);
                return;
            }

            if (isManualPrice) {
                // Rabatt im selben Variant-Eintrag auf 0 setzen (Value + UI), aber nichts propagieren
                const discountWrapper = parentBox.querySelector(".itemBasketBox__discount .spDiscount");
                const discountInput   = discountWrapper?.querySelector("input.percent_discount, input.percent_discount_all_variants");
                const discountDisplay = discountWrapper?.querySelector(".editable-display");
                if (discountInput) {
                    discountInput.value = 0;
                    discountInput.dispatchEvent(new Event('input', { bubbles: true }));
                }
                if (discountDisplay) {
                    discountDisplay.textContent = "0 %";
                    discountDisplay.classList.remove("discount");
                }

                // Nur die Anzeige des Preises setzen (Backend macht die echte Berechnung via bestehendem AJAX)
                display.textContent = `${value.toFixed(2)} €`;
                display.classList.remove("discount");
                input.dispatchEvent(new Event('input', { bubbles: true }));
            }
            //  NEU: Preis-Propagation wie bei js-updateSizesColors, aber mit Euro
            else if (mode === "salesPersonPrice") {
                display.textContent = `${value.toFixed(2)} €`;
                display.classList.remove("discount");

                // Alle Varianten mit gleichem data-id im aktuellen Warenkorb updaten
                basketContainer.querySelectorAll(`.itemBasketBox.sizeVariant[data-id="${dataId}"]`).forEach(variant => {
                    const variantDisplay = variant.querySelector(".itemBasketBox__manual_price .editable-display");
                    const variantInput   = variant.querySelector(".itemBasketBox__manual_price input.manual_price_discount");
                    const variantDiscount = variant.querySelector(".itemBasketBox__discount input.percent_discount");

                    if (variantDisplay) variantDisplay.textContent = `${value.toFixed(2)} €`;
                    if (variantInput) {
                        variantInput.value = value;
                        variantInput.dispatchEvent(new Event('input', { bubbles: true }));
                    }
                    if (variantDiscount) {
                        variantDiscount.value = 0; // Rabatt zurücksetzen
                        variantDiscount.dispatchEvent(new Event('input', { bubbles: true }));
                    }
                });
            }

            else if (mode === "colorVariantPrice") {
                display.textContent = `${value.toFixed(2)} €`;
                display.classList.remove("discount");

                // alle Size-Varianten der aktuellen Farbe updaten
                let next = parentBox.nextElementSibling;
                while (next) {
                    if (
                        (next.classList.contains("itemBasketBox") && next.classList.contains("colorVariant")) ||
                        (next.classList.contains("itemBasketBox") && next.classList.contains("salesPersonDiscount"))
                    ) break;

                    if (
                        next.classList.contains("itemBasketBox") &&
                        next.classList.contains("sizeVariant") &&
                        next.getAttribute("data-id") === dataId
                    ) {
                        const variantDisplay = next.querySelector(".itemBasketBox__manual_price .editable-display");
                        const variantInput   = next.querySelector(".itemBasketBox__manual_price input.manual_price_discount");
                        const variantDiscount = next.querySelector(".itemBasketBox__discount input.percent_discount");

                        if (variantDisplay) variantDisplay.textContent = `${value.toFixed(2)} €`;
                        if (variantInput) {
                            variantInput.value = value;
                            variantInput.dispatchEvent(new Event('input', { bubbles: true }));
                        }
                        if (variantDiscount) {
                            variantDiscount.value = 0; // Rabatt zurücksetzen
                            variantDiscount.dispatchEvent(new Event('input', { bubbles: true }));
                        }
                    }
                    next = next.nextElementSibling;
                }
            }


            else {
                display.textContent = value > 0 ? `- ${formatDiscount(value)} %` : `${formatDiscount(value)} %`;
                display.classList.toggle("discount", value > 0);
                input.dispatchEvent(new Event('input', { bubbles: true }));

                // --- NEU: manuellen Preis zurücksetzen ---
                const manualPriceInput = parentBox.querySelector("input.manual_price_discount");
                if (manualPriceInput) {
                    manualPriceInput.value = "";
                    manualPriceInput.dispatchEvent(new Event('input', { bubbles: true }));
                }

                if (mode === "salesPerson") {
                    basketContainer.querySelectorAll(`.itemBasketBox.sizeVariant[data-id="${dataId}"]`).forEach(variant => {
                        const variantDisplay = variant.querySelector(".itemBasketBox__discount .spDiscount .editable-display");
                        const variantInput   = variant.querySelector(".itemBasketBox__discount input.percent_discount");
                        const variantManual  = variant.querySelector("input.manual_price_discount");

                        if (variantDisplay) {
                            variantDisplay.textContent = value > 0 ? `- ${formatDiscount(value)} %` : `${formatDiscount(value)} %`;
                            variantDisplay.classList.toggle("discount", value > 0);
                        }
                        if (variantInput) {
                            variantInput.value = value;
                            variantInput.dispatchEvent(new Event('input', { bubbles: true }));
                        }
                        if (variantManual) {
                            variantManual.value = "";
                            variantManual.dispatchEvent(new Event('input', { bubbles: true }));
                        }
                    });
                }

                if (mode === "colorVariant") {
                    let next = parentBox.nextElementSibling;
                    while (next) {
                        if (
                            (next.classList.contains("itemBasketBox") && next.classList.contains("colorVariant")) ||
                            (next.classList.contains("itemBasketBox") && next.classList.contains("salesPersonDiscount"))
                        ) break;

                        if (
                            next.classList.contains("itemBasketBox") &&
                            next.classList.contains("sizeVariant") &&
                            next.getAttribute("data-id") === dataId
                        ) {
                            const variantDisplay = next.querySelector(".itemBasketBox__discount .spDiscount .editable-display");
                            const variantInput   = next.querySelector(".itemBasketBox__discount input.percent_discount");
                            const variantManual  = next.querySelector("input.manual_price_discount");

                            if (variantDisplay) {
                                variantDisplay.textContent = value > 0 ? `- ${formatDiscount(value)} %` : `${formatDiscount(value)} %`;
                                variantDisplay.classList.toggle("discount", value > 0);
                            }
                            if (variantInput) {
                                variantInput.value = value;
                                variantInput.dispatchEvent(new Event('input', { bubbles: true }));
                            }
                            if (variantManual) {
                                variantManual.value = "";
                                variantManual.dispatchEvent(new Event('input', { bubbles: true }));
                            }
                        }
                        next = next.nextElementSibling;
                    }
                }
            }

            // UI zurück togglen
            display.style.display = "inline-block";
            input.style.display = "none";
            editIcon.style.display = "inline-block";
            saveIcon.style.display = "none";

            currentEditing = null;
        };

        const cancelEdit = (wrap) => {
            const disp  = wrap.querySelector(".editable-display");
            const inp   = wrap.querySelector("input.percent_discount, input.percent_discount_all_variants, input.manual_price_discount, input[type='number']");
            const eIcon = wrap.querySelector(".icon-edit");
            const sIcon = wrap.querySelector(".icon-save");

            if (inp && originalValue !== null) inp.value = originalValue;
            if (disp && originalText !== null) {
                disp.textContent = originalText;
                disp.classList.toggle("discount", originalClass);
            }

            disp.style.display = "inline-block";
            inp.style.display = "none";
            eIcon.style.display = "inline-block";
            sIcon.style.display = "none";

            currentEditing = null;
        };

        // Events
        editIcon.addEventListener("click", e => { e.preventDefault(); e.stopPropagation(); toggleToEdit(); });
        saveIcon.addEventListener("click", e => { e.preventDefault(); e.stopPropagation(); toggleToDisplay(); });
        input.addEventListener("keydown", e => {
            if (e.key === "Enter") { e.preventDefault(); e.stopPropagation(); toggleToDisplay(); }
            if (e.key === "Escape") { e.preventDefault(); e.stopPropagation(); cancelEdit(wrapper); }
        });
        display.addEventListener("click", e => { e.preventDefault(); e.stopPropagation(); toggleToEdit(); });

        // Klick außerhalb → Abbruch
        document.addEventListener("click", e => {
            if (currentEditing && !currentEditing.contains(e.target)) {
                cancelEdit(currentEditing);
            }
        });

        // Initialzustand
        input.style.display = "none";
        saveIcon.style.display = "none";

        const initialValue = parseFloat(input.value);
        if (!isNaN(initialValue) && initialValue > 0) {
            if (isManualPrice) {
                display.textContent = `${initialValue.toFixed(2)} €`;
            } else {
                display.textContent = `- ${formatDiscount(initialValue)} %`;
                display.classList.add("discount");
            }
        }
    };

    // Initialisierung
    document.querySelectorAll(".js-editableInput:not(.js-manualPriceInput)").forEach(w => setupEditable(w, "normal"));
    document.querySelectorAll(".salesPersonDiscount .js-updateSizesColors").forEach(w => setupEditable(w, "salesPerson"));
    document.querySelectorAll(".itemBasketBox.colorVariant .js-updateSizes").forEach(w => setupEditable(w, "colorVariant"));
    document.querySelectorAll(".js-manualPriceInput").forEach(w => setupEditable(w, "manualPrice"));
    document.querySelectorAll(".salesPersonDiscount .js-updateSizesColorsPrice").forEach(w => setupEditable(w, "salesPersonPrice"));
    document.querySelectorAll(".itemBasketBox.colorVariant .js-updateSizesPrice").forEach(w => setupEditable(w, "colorVariantPrice"));


}
